import { render, staticRenderFns } from "./RibbonReplacementsMerc.vue?vue&type=template&id=b870ee76&scoped=true&"
import script from "./RibbonReplacementsMerc.vue?vue&type=script&lang=js&"
export * from "./RibbonReplacementsMerc.vue?vue&type=script&lang=js&"
import style0 from "./RibbonReplacementsMerc.vue?vue&type=style&index=0&id=b870ee76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b870ee76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
